import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'Teranet-ClientTitle',
  templateUrl: './client-title.component.html',
  styleUrls: ['./client-title.component.scss'],
})
export class ClientTitleComponent implements OnInit {
  @Input() ClientTitle: string;
  @Input() IconName: string;
  constructor() {}
  ngOnInit() {}
}
